import React from "react";
import { PageLayout, PageContent, PageHeader, Callout, Skeleton } from "../../ui";
import { useUserInfo } from "./hooks/useUserInfo";
import { usePasswordChange } from "./hooks/usePasswordChange";
import { UserInfoView } from "./components/UserInfoView";
import { PasswordChangeView } from "./components/PasswordChangeView";

/**
 * Personal Profile (016 §4): user info + change password. Sign out moved to the
 * avatar menu; this replaces the personal half of the old /control-center page.
 */
export default function ProfileSettingsPage() {
  const { userInfo, isLoading: isLoadingUserInfo } = useUserInfo();
  const {
    currentPassword,
    newPassword,
    setCurrentPassword,
    setNewPassword,
    changePassword,
  } = usePasswordChange();

  return (
    <PageLayout>
      <PageContent maxWidth="3xl">
        <PageHeader title="Profile" description="Your account details and password." />

        {isLoadingUserInfo ? (
          <div className="mt-6 space-y-6">
            {[0, 1].map((c) => (
              <div
                key={c}
                className="bg-card rounded-lg shadow-sm border border-border p-6 space-y-4"
              >
                <Skeleton variant="text" height={18} width={160} />
                <Skeleton height={40} />
                <Skeleton height={40} />
              </div>
            ))}
          </div>
        ) : !userInfo ? (
          <Callout className="mt-8 border-destructive/30 bg-destructive/10 text-destructive">
            Failed to load user information.
          </Callout>
        ) : (
          <div className="mt-6">
            <UserInfoView userInfo={userInfo} />
            <PasswordChangeView
              currentPassword={currentPassword}
              newPassword={newPassword}
              onCurrentPasswordChange={setCurrentPassword}
              onNewPasswordChange={setNewPassword}
              onChangePassword={changePassword}
            />
          </div>
        )}
      </PageContent>
    </PageLayout>
  );
}
